import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class MegaHeaderModuleTerms extends BaseTerms {}
